<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-arrowleft`]" width="1em" height="1em" v-bind="$attrs"><path d="M9.91037 5.52881C10.1696 5.26922 10.1696 4.848 9.91037 4.58839C9.65078 4.3288 9.22967 4.32902 8.96994 4.58839L9.91037 5.52881ZM8.96994 11.2876C9.22966 11.5465 9.65092 11.5469 9.91037 11.2876C10.17 11.028 10.1697 10.6059 9.91037 10.3462L7.50119 7.93799L9.91037 5.52881L9.43967 5.05909L8.96994 4.58839L6.30295 7.25538L6.23654 7.32862C5.92734 7.70765 5.94963 8.26729 6.30295 8.62061L8.96994 11.2876Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineArrowleft',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
